// Localization is based on '@ngx-translate/core';
// Please be familiar with official documentations first => https://github.com/ngx-translate/core

import { Injectable } from '@angular/core';
import { DateAdapter, MatDateFormats } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MY_FORMATS_EN, MY_FORMATS_ES } from '../models/date_formats';

export interface Locale {
  lang: string;
  data: any;
}

const LOCALIZATION_LOCAL_STORAGE_KEY = 'language';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  // Private properties
  private langIds: any = [];
  actualLang$: Observable<string>;
  actualLangSubject: BehaviorSubject<string>;
  private dateFormatSubject = new BehaviorSubject<MatDateFormats>(MY_FORMATS_ES);
  dateFormat$ = this.dateFormatSubject.asObservable();


  constructor(private translate: TranslateService,private dateAdapter: DateAdapter<any>) {
    // add new langIds to the list
    this.translate.addLangs(['es','en','ch','jp','de','fr']);

    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang('es');
    this.actualLangSubject = new BehaviorSubject<string>("es");
    this.actualLang$ = this.actualLangSubject.asObservable();
  }

  loadTranslations(...args: Locale[]): void {
    const locales = [...args];

    locales.forEach((locale) => {
      // use setTranslation() with the third argument set to true
      // to append translations instead of replacing them
      this.translate.setTranslation(locale.lang, locale.data, true);
      this.langIds.push(locale.lang);
    });

    // add new languages to the list
    this.translate.addLangs(this.langIds);
    this.translate.use(this.getSelectedLanguage());
    this.actualLangSubject.next(this.getSelectedLanguage());
  }
  loadTranslations_xarray(args: Locale[]): void {
    const locales = args;

    locales.forEach((locale) => {
      // use setTranslation() with the third argument set to true
      // to append translations instead of replacing them
      this.translate.setTranslation(locale.lang, locale.data, true);
      this.langIds.push(locale.lang);
    });

    // add new languages to the list
    this.translate.addLangs(this.langIds);
    this.translate.use(this.getSelectedLanguage());
    this.actualLangSubject.next(this.getSelectedLanguage());
  }

  setLanguage(lang: string) {
    if (lang) {
      this.translate.use(this.translate.getDefaultLang());
      this.translate.use(lang);
      this.actualLangSubject.next(lang);
      localStorage.setItem(LOCALIZATION_LOCAL_STORAGE_KEY, lang);
      this.dateAdapter.setLocale(lang=="en"?"en-US":"es-ES");
      if (lang === 'es') {
        this.dateFormatSubject.next(MY_FORMATS_ES);
      } else {
        this.dateFormatSubject.next(MY_FORMATS_EN);
      }
    }
  }
  getAsyncSelectedLanguage=():Observable<string>=>{
    return this.actualLang$;
  }
  /**
   * Returns selected language
   */
  getSelectedLanguage(): any {
    return (
      localStorage.getItem(LOCALIZATION_LOCAL_STORAGE_KEY) ||
      this.translate.getDefaultLang()
    );
  }
}
